// extracted by mini-css-extract-plugin
export default {"fade-in":"ColorSelector_fade-in__VjXwC","fadeInAnimation":"ColorSelector_fadeInAnimation__u31u3","image":"ColorSelector_image__Rnbdf"};